import actions from './actions';
import reducer from './reducer';

const rxRequests = {
    actions,
    reducer,
    name: 'rxRequests',
};

export default rxRequests; 